export default "__VITE_ASSET__BxSGh3ZQ__"